module.exports = __webpack_public_path__ + "static/media/jac.20b5dfd1.png";